export default [
    {
        path: '/companies',
        name: 'companies',
        component: () => import(/* webpackChunkName: "Companies" */ '@/views/companies/Index.vue'),
        meta: {
            title: 'Opdrachtgevers',
            requiresAuth: true,
        }
    },
    {
        path: '/companies/create',
        name: 'addCompany',
        component: () => import(/* webpackChunkName: "CompaniesCreate" */ '@/views/companies/Create.vue'),
        meta: {
            title: 'Opdrachtgever toevoegen',
            requiresAuth: true,
        }
    },
    {
        path: '/companies/edit/:id',
        name: 'editCompany',
        component: () => import(/* webpackChunkName: "CompaniesEdit" */ '@/views/companies/Edit.vue'),
        meta: {
            title: 'Opdrachtgever bewerken',
            requiresAuth: true,
        }
    }
];